<template>
 <!-- Tab panes -->
<div id="nav-5-3-primary-ver" class="tab-content g-pt-20 g-pt-0--md">
    <div class="g-max-width-645 text-center mx-auto g-mt-60 g-mb-0">
        <h1 class="h1">Frequently Asked Questions</h1>
        <p class="g-font-size-20">Below are the answers to some frequently asked questions.</p>
    </div>
    <div v-if="items != null" v-for="(group, index) of items.keys()">
        <help-item :id="group.replace(/\s+/g, '') + '-div'" :section="group" :items="items.get(group)"></help-item>
        <br><br><br>
    </div>
</div>
<!-- End Tab panes -->
</template>
<script>
import General from "@/components/portal/helpData/helpList/General";
import Order from "@/components/portal/helpData/helpList/Order";
import TrackOrder from "@/components/portal/helpData/helpList/TrackOrder";
import Frames from "@/components/portal/helpData/helpList/Frames";
import Resources from "@/components/portal/helpData/helpList/Resources";
import MyAccount from "@/components/portal/helpData/helpList/MyAccount";
import Vue from 'vue';
import HelpItem from './helpList/HelpItem.vue';
export default {
     components: {HelpItem, General, Order, TrackOrder, Frames, Resources, MyAccount},
     props: ["items"],
     data() {
         return {
             //items: null
         };
     },
     async created() {
        try {
            //console.log("Bearer " + localStorage.getItem("token"));
            // var response = await fetch(Vue.config.API_ENDPOINT + 'CMS/GetHelpFAQs', {
            //     method: 'get',
            //     headers: {
            //         'Authorization': "Bearer " + localStorage.getItem("token")
            //     }
            // })
            // console.log(response);
            // let apiitems = await response.json();
            // console.log("API items");
            // console.log(apiitems);
            // let sections = new Set();
            // console.log(sections);
            // for (let curItem of apiitems)
            // {
            //     console.log("API item");
            //     console.log(curItem);
            //     sections.add(curItem.section)
            // }
            // //let sections = apiitems.reduce((sectionSet, curItem) => sectionSet.add(curItem.section), new Set());
            // console.log(sections);
            // this.items = [...sections].reduce((resultMap, curSection) =>
            //                     resultMap.set(curSection,
            //                     apiitems.filter(x => x.section == curSection)),
            //                     new Map());
            //console.log(sections);
            console.log(this.items);
        } catch(ex) {
            console.log(ex);
        }
     },
}
</script>


// WEBPACK FOOTER //
// HelpCenter.vue?585ae365